export class OrderCanceledError extends Error {

}